import React, { useState } from "react";
import {
  Smartphone, Briefcase, Bike, Tv, Truck, Sofa, Shirt, BookOpen,
  PawPrint, Wrench, Car, Home, Calendar, Tag, BadgePercent, CalendarPlus,
} from "lucide-react";

const MAP = {
  smartphone: Smartphone,
  briefcase: Briefcase,
  bike: Bike,
  tv: Tv,
  truck: Truck,
  sofa: Sofa,
  shirt: Shirt,
  "book-open": BookOpen,
  "paw-print": PawPrint,
  wrench: Wrench,
  car: Car,
  home: Home,
  calendar: Calendar,
  "badge-percent": BadgePercent,
  "calendar-plus": CalendarPlus,
};

/**
 * CategoryIcon — Iter 250 fallback chain (founder directive):
 *   1. `thumbnailUrl` → Cloudinary photo tile (roots only)
 *   2. `emoji`        → per-category emoji (roots + all 339 subcats)
 *   3. `name` → mapped lucide glyph (last-resort)
 *   4. Tag glyph      → nothing else matched
 *
 * When a thumbnail load fails at runtime, we advance to the next step
 * in the chain instead of leaving an empty box (retry survivability
 * called out by the iter-74 testing agent).
 */
export default function CategoryIcon({
  name,
  thumbnailUrl,
  emoji,
  className = "w-5 h-5",
  alt,
}) {
  const [thumbFailed, setThumbFailed] = useState(false);
  if (thumbnailUrl && !thumbFailed) {
    return (
      <img
        src={thumbnailUrl}
        alt={alt || name || "category"}
        loading="lazy"
        data-testid="category-thumbnail"
        className={`${className} rounded-md object-cover`}
        onError={() => setThumbFailed(true)}
      />
    );
  }
  if (emoji) {
    return (
      <span
        role="img"
        aria-label={alt || name || "category"}
        data-testid="category-emoji"
        className={`inline-flex items-center justify-center leading-none ${className}`}
        style={{ fontSize: "1.5em" }}
      >
        {emoji}
      </span>
    );
  }
  const Cmp = MAP[name] || Tag;
  return <Cmp className={className} data-testid="category-glyph" />;
}
